import { pWarn } from '_/helpers/logger';

import Select2 from '../Select2/Select2';

export default {
    components: { Select2 },
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        canCreateSearchChoice: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
        },
        flattenToOptgroups: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        isActiveEntryFilter: {
            default: null,
            type: String,
        },
        lazyLoading: {
            type: Boolean,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        name: {
            required: true,
            type: String,
        },
        optionsData: {
            type: Array,
        },
        placeholder: {
            type: String,
        },
        preloadDataConfig: {
            default() {
                return {
                    method: 'get',
                    payload: {
                        include_relations: false,
                    },
                    resultsObjectPath: 'body.body.modules',
                    valuesOfInterest: {
                        id: 'id',
                        text: 'name',
                    },
                    url: '/api/modules',
                };
            },
            type: Object,
        },
        preselectFirst: {
            default: false,
            type: Boolean,
        },
        refreshFields: {
            type: Number,
        },
        relatedTableName: {
            type: [Boolean, String],
        },
        required: {
            type: Boolean,
        },
        value: {
            default: null,
            type: [Array, Number, Object, String],
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    methods: {
        onChange({ id, value }) {
            this.$emit('change', {
                id,
                name: this.name,
                value,
            });
        },
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `Select2.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.$forceUpdate();
            }
        },
    },
};
